<template>
  <v-app-bar
    :flat="!hover"
    :color="isTransparent ? 'transparent' : `${headerColor}`"
    :key="componentKey"
    @mouseenter="setBackground(true)"
    @mouseleave="setBackground(false)"
    fixed
    prominent
    hide-on-scroll
    v-scroll.parent="scrollListener"
  >
    <v-container fill-height>
      <div
        class="d-flex justify-space-between align-center align-content-center"
        style="width: 100%"
      >
        <img
            @click="redirectToMainPage"
            src="@/assets/images/medgate_logo_blue.png" style="object-fit:contain; cursor: pointer"
            :width="logoWidth"
            height="auto"
        />
        <div class="hidden d-md-flex justify-space-around align-center">
          <v-toolbar-items class="hidden-sm-and-down">
            <template v-for="(item, key) in mainBarItems">
              <a :href="item.link" :key="key">
                <span
                  :class="`custom-link ml-7 mr-3`"
                  :style="{ color: item.item === 'Shop' ? '#40ecb8' : '' }"
                >
                  {{ item.item }}
                  <v-icon right v-if="item.link === Object(item.link)"
                    >mdi-chevron-down</v-icon
                  ></span
                >
              </a>
            </template>
          </v-toolbar-items>
        </div>
        <div class="d-block d-md-none">
          <slot name="nav-drawer"></slot>
        </div>
      </div>
      <!--			<v-row justify="space-between red">-->
      <!--				<v-col cols="4" class="black">-->
      <!--					<router-link to="/">-->
      <!--						<img-->
      <!--							v-if="headerColor == 'white'"-->
      <!--							src="@/assets/images/medgate_logo_blue.png"-->
      <!--							width="175px"-->
      <!--							style="object-fit:contain"-->
      <!--						>-->
      <!--						<img-->
      <!--							v-else-->
      <!--							src="@/assets/images/medgate_logo_white.png"-->
      <!--							width="175px"-->
      <!--							style="object-fit:contain"-->
      <!--						>-->
      <!--					</router-link>-->
      <!--				</v-col>-->
      <!--				<v-col cols="8">-->
      <!--					&lt;!&ndash; Top &ndash;&gt;-->
      <!--					<v-row align="center" class="pb-2 hidden-md-and-down">-->
      <!--						<v-spacer></v-spacer>-->

      <!--						<router-link v-for="(item, key) in topBarItems" :key="key" :to="item.link">-->
      <!--							<v-row align="center" :class="`ml-7 mr-3 ${textColor}`">-->
      <!--								<img-->
      <!--									:src="headerColor == 'white' ? item.blueIcon : item.whiteIcon"-->
      <!--									width="20px"-->
      <!--									height="20px"-->
      <!--									class="mr-2"-->
      <!--								>-->
      <!--								<span-->
      <!--									class="text-hover d-inline"-->
      <!--									:class="{'active-link': item.active}"-->
      <!--								>-->
      <!--									{{ item.item }}-->
      <!--								</span>-->
      <!--							</v-row>-->
      <!--						</router-link>-->
      <!--					</v-row>-->

      <!--					&lt;!&ndash; Main &ndash;&gt;-->
      <!--					<v-row class="hidden-md-and-down">-->
      <!--						<v-spacer></v-spacer>-->
      <!--						<span v-for="(item, key) in mainBarItems" :key="key">-->
      <!--							<router-link v-if="!item.redirect" :to="(item.link !== Object(item.link)) ? item.link : '/'">-->
      <!--								<v-toolbar-items :class="`hidden-sm-and-down ${textColor}`">-->
      <!--									<span-->
      <!--										class="text-hover ml-7 mr-3"-->
      <!--										:class="{'active-link': item.active}"-->
      <!--									>-->
      <!--										{{ item.item }}-->
      <!--										<v-icon right v-if="item.link === Object(item.link)">mdi-chevron-down</v-icon>-->
      <!--									</span>-->
      <!--								</v-toolbar-items>-->
      <!--							</router-link>-->
      <!--							<span v-if="item.redirect">-->
      <!--								<a :href="item.link">-->
      <!--									<v-toolbar-items :class="`hidden-sm-and-down ${textColor}`">-->
      <!--										<span-->
      <!--											class="text-hover ml-7 mr-3"-->
      <!--											:class="{'active-link': item.active}"-->
      <!--										>-->
      <!--											{{ item.item }}-->
      <!--											<v-icon right v-if="item.link === Object(item.link)">mdi-chevron-down</v-icon>-->
      <!--										</span>-->
      <!--									</v-toolbar-items>-->
      <!--								</a>-->
      <!--							</span>-->
      <!--						</span>-->

      <!--						&lt;!&ndash; <router-link v-for="(item, key) in mainBarItems" :key="key" :to="(item.link !== Object(item.link)) ? item.link : '/'">-->
      <!--							<v-toolbar-items :class="`hidden-sm-and-down ${textColor}`">-->
      <!--								<span-->
      <!--									class="text-hover ml-7 mr-3"-->
      <!--									:class="{'active-link': item.active}"-->
      <!--								>-->
      <!--									{{ item.item }}-->
      <!--									<v-icon right v-if="item.link === Object(item.link)">mdi-chevron-down</v-icon>-->
      <!--								</span>-->
      <!--							</v-toolbar-items>-->
      <!--						</router-link> &ndash;&gt;-->
      <!--					</v-row>-->
      <!--					<v-row align="center" justify="end" class="hidden-lg-and-up">-->
      <!--						<slot name="nav-drawer"></slot>-->
      <!--					</v-row>-->
      <!--				</v-col>-->
      <!--			</v-row>-->
      <!--      -->
    </v-container>
  </v-app-bar>
</template>

<script>
import { headerMenus, topHeaderMenus } from "@/config/menu.js";

export default {
  name: "BaseHeader",
  data: () => ({
    hover: false,
    isTransparent: false,
    componentKey: 0, //use to rerender component
    currentLink: "",
    scrollPosition: 0,
    topBarItems: topHeaderMenus,
    mainBarItems: headerMenus
  }),
  watch: {
    $route: {
      handler: function(value) {
        let currentName = value.name;

        let topBarItems = this.topBarItems;

        let mainBarItems = this.mainBarItems;

        let topBarItemKey = topBarItems.findIndex(
          item => item.name === currentName
        );

        /**
         * if findIndex return -1 meaning index not found
         */
        if (topBarItemKey >= 0) {
          topBarItems.map((item, key) => {
            if (key == topBarItemKey) {
              item.active = true;
            } else {
              item.active = false;
            }

            return item;
          });

          /**
           * if index is found in this.topBarItems
           * make all active key in this.mainBarItems to false
           */
          mainBarItems.map(item => {
            item.active = false;

            return item;
          });

          return;
        }

        let mainBarItemKey = mainBarItems.findIndex(
          item => item.name === currentName
        );

        mainBarItems.map((item, key) => {
          if (key == mainBarItemKey) {
            item.active = true;
          } else {
            item.active = false;
          }

          return item;
        });

        /**
         * if index is found in this.mainBarItems
         * make all active key in this.topBarItems to false
         */
        topBarItems.map(item => {
          item.active = false;

          return item;
        });

        return;
      },
      immediate: true
    }
  },
  computed: {
    headerColor() {
      return this.$store.getters["page/headerColor"];
    },
    textColor() {
      return this.$store.getters["page/textColor"];
    },
    logoWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "30%";
        case "sm":
          return "25%";
        case "md":
          return "20%";
        case "lg":
          return "15%";
        case "xl":
          return "10%";
      }
      return "20%";
    }
  },
  mounted() {
    //
    console.log({ headerMenus });
  },
  methods: {
    scrollListener() {
      // get the html tag (html is the parent scrollable)
      let app = document.getElementsByTagName("html");

      /**
       * make app-bar color transparent when scrollTop = 0 and
       * rerender component to avoid "merged text" UI error
       *
       * Scenario:
       * When app-bar is on top, scroll down then scroll to top repeatedly and
       * see app-bar
       */
      this.scrollPosition = app[0].scrollTop;

      if (this.scrollPosition == 0) {
        this.isTransparent = false;

        setTimeout(() => {
          this.componentKey++;
        }, 50);

        return;
      }

      this.isTransparent = false;

      return;
    },
    setBackground(hover) {
      this.hover = hover;

      if (this.scrollPosition == 0) {
        this.isTransparent = !this.isTransparent;
      }
    },
    redirectToMainPage() {
      window.location.href = 'https://medgate.ph/';
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.v-toolbar {
  span {
    font-weight: bold;
    font-size: 17px;
  }
}

.main-menu-wrapper {
  max-width: 100%;
  padding: 20px 100px;
}

.custom-link:hover {
  color: $accent-blue !important;
}
</style>
